function TeamIconDark() {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.2502 27.7082V26.2498C26.2502 23.0282 23.6385 20.4165 20.4168 20.4165H14.5835C11.3618 20.4165 8.75016 23.0282 8.75016 26.2498V27.7082M33.5418 27.7082V26.2498C33.5418 23.0282 30.9302 20.4165 27.7085 20.4165H26.9793M1.4585 27.7082V26.2498C1.4585 23.0282 4.07017 20.4165 7.29183 20.4165H8.021M24.7918 16.0415C27.2081 16.0415 29.1668 14.0828 29.1668 11.6665C29.1668 9.25026 27.2081 7.2915 24.7918 7.2915M10.2085 16.0415C7.79225 16.0415 5.8335 14.0828 5.8335 11.6665C5.8335 9.25026 7.79225 7.2915 10.2085 7.2915M21.8752 11.6665C21.8752 14.0827 19.9164 16.0415 17.5002 16.0415C15.0839 16.0415 13.1252 14.0827 13.1252 11.6665C13.1252 9.25026 15.0839 7.2915 17.5002 7.2915C19.9164 7.2915 21.8752 9.25026 21.8752 11.6665Z"
        stroke="#F6AE2D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function TeamIconLight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M26.75 28.1589V26.7005C26.75 23.4789 24.1383 20.8672 20.9167 20.8672H15.0833C11.8617 20.8672 9.25 23.4789 9.25 26.7005V28.1589M34.0417 28.1589V26.7005C34.0417 23.4789 31.43 20.8672 28.2083 20.8672H27.4792M1.95833 28.1589V26.7005C1.95833 23.4789 4.57 20.8672 7.79166 20.8672H8.52083M25.2917 16.4922C27.7079 16.4922 29.6667 14.5334 29.6667 12.1172C29.6667 9.70094 27.7079 7.74219 25.2917 7.74219M10.7083 16.4922C8.29208 16.4922 6.33333 14.5334 6.33333 12.1172C6.33333 9.70094 8.29208 7.74219 10.7083 7.74219M22.375 12.1172C22.375 14.5334 20.4162 16.4922 18 16.4922C15.5838 16.4922 13.625 14.5334 13.625 12.1172C13.625 9.70094 15.5838 7.74219 18 7.74219C20.4162 7.74219 22.375 9.70094 22.375 12.1172Z"
        stroke="#BCCCDC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.75 28.1589V26.7005C26.75 23.4789 24.1383 20.8672 20.9167 20.8672H15.0833C11.8617 20.8672 9.25 23.4789 9.25 26.7005V28.1589M34.0417 28.1589V26.7005C34.0417 23.4789 31.43 20.8672 28.2083 20.8672H27.4792M1.95833 28.1589V26.7005C1.95833 23.4789 4.57 20.8672 7.79166 20.8672H8.52083M25.2917 16.4922C27.7079 16.4922 29.6667 14.5334 29.6667 12.1172C29.6667 9.70094 27.7079 7.74219 25.2917 7.74219M10.7083 16.4922C8.29208 16.4922 6.33333 14.5334 6.33333 12.1172C6.33333 9.70094 8.29208 7.74219 10.7083 7.74219M22.375 12.1172C22.375 14.5334 20.4162 16.4922 18 16.4922C15.5838 16.4922 13.625 14.5334 13.625 12.1172C13.625 9.70094 15.5838 7.74219 18 7.74219C20.4162 7.74219 22.375 9.70094 22.375 12.1172Z"
        stroke="#1C202A"
        strokeOpacity="0.3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function TeamIcon({
  mode = 'dark',
}: {
  mode?: 'light' | 'dark';
}) {
  return <>{mode === 'dark' ? <TeamIconDark /> : <TeamIconLight />}</>;
}
